/**
 * Safely gets a value from sessionStorage with a fallback
 */
export const getFromSessionStorage = <T>(key: string, fallback: T): T => {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') {
    return fallback;
  }

  try {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : fallback;
  } catch (e) {
    console.warn(`Error reading ${key} from sessionStorage:`, e);
    return fallback;
  }
};

/**
 * Safely sets a value in sessionStorage
 */
export const setInSessionStorage = <T>(key: string, value: T): boolean => {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') {
    return false;
  }

  try {
    sessionStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (e) {
    console.warn(`Error saving ${key} to sessionStorage:`, e);
    return false;
  }
};

/**
 * Gets the saved player volume
 */
export const getSavedVolume = (): number => {
  return parseFloat(getFromSessionStorage<string>('playerVolume', '1'));
};

/**
 * Saves the player volume
 */
export const saveVolume = (volume: number): boolean => {
  return setInSessionStorage('playerVolume', volume.toString());
};
